import "../../../styles/dateTime.css";
import "./dev_responsive.css";
import "./styles.css";

import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import Datetime from "react-datetime";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../../../api/api";
import {
  calender_image,
  dashboard_popup_teacher_profile_details_icon,
  dashboard_popup_welcome_image,
  email_image,
  gender_image,
  grade_image,
  language_image,
  location_image,
  profile_image,
  selectedImage1,
  animal_avtar_1,
  animal_avtar_2,
  animal_avtar_3,
  animal_avtar_4,
  animal_avtar_5,
  animal_avtar_6,
  animal_avtar_7,
  animal_avtar_8,
  animal_avtar_9,
  animal_avtar_10,
  uplode_image,
} from "../../../../../assets/images/images";
import { useAuth } from "../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../state/global/slice.tsx";
import {
  isRequired,
  isValidEmail,
  isValidMobileNumber,
  isValidName,
} from "../../../../../utils/validator";

import AOS from "aos";
import "aos/dist/aos.css";
import { allCountries } from "country-telephone-data";
import dayjs from "dayjs";
import Autocomplete from "react-google-autocomplete";
import girl_under_age_1 from "../../../../../assets/images/girl_under_age_1.png";
import girl_under_age_2 from "../../../../../assets/images/girl_under_age_2.png";
import girl_under_age_3 from "../../../../../assets/images/girl_under_age_3.png";
import { GOOGLE_MAP_KEY } from "../../../../../consts/constants";
import { compressImage } from "../../../../../utils/CompressImage";
import GetCountryCodeViaIp from "../../../../../utils/GetCountryCode.js";
import { genders } from "../../../../../utils/consts";
import {
  changeScrollPopup,
  isOthersGender,
} from "../../../../../utils/utlis.js";
import CropProfileImageModal from "../CropProfileImageModal.js";

import { useNavigate } from "react-router";
import boy_under_age_1 from "../../../../../assets/images/boy_under_age_1.png";
import boy_under_age_2 from "../../../../../assets/images/boy_under_age_2.png";
import boy_under_age_3 from "../../../../../assets/images/boy_under_age_3.png";
import FilteredInput from "../../../../../components/FilteredInput/FilteredInput";
import FilteredTextarea from "../../../../../components/FilteredInput/FilteredTextArea";
import {
  getProfileDetails,
  resetProfileDetails,
} from "../../../../../state/actions/getProfileDetailsAction.ts";
import {
  getAIGeneratedCourses,
  getAIGeneratedLessons,
} from "./teacher/utils.js";
// import lessonGif from "../../../../../assets/images/lessonGIF.gif";
import { PlusIcon } from "../../../../../components/FileRepo/Icons.jsx";
import Loader from "../teacher/course/Modals/Loader.jsx";
import { InterestIcon, SubjectIcon } from "./Icons/Icons.jsx";
import FloatingDateTime from "./FloatingDateTime.jsx";
import SubjectSelector from "./subjects/SubjectSelector.jsx";
import useSubjectSelection from "./subjects/useSubjectSelection.js";

// const _preloadLessonGif = new Image();
// _preloadLessonGif.src = lessonGif;

const StudentPopupSection = (props) => {
  const convertImagePathToBlob = async (imagePath) => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new File([blob], "image.png", { type: "image/png" });
  };

  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.globalState);
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const navigate = useNavigate();
  const [Addtointerest, setAddtointerest] = useState([]);
  const [gradedetails, setGradedetails] = useState([]);
  const [showWelcomeFolder, setShowWelcomeFolder] = useState(true); // State to control the visibility of the welcome folder
  const [AddtoLanguages, setAddtoLanguages] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const maxBirthDate = (() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 4);
    return d;
  })();
  const { token } = useAuth();
  const [tempVariable, setTempVariable] = useState(null);
  const [selectedImage, setSelectedImage] = useState(selectedImage1 || null);

  const redirectPath = localStorage.getItem("redirectAfterSignup");
  const redirectToCourse = localStorage.getItem("redirectToCourse");
  const [imageUploaded, setImageUploaded] = useState(false);
  const [uplodedImage, setUplodedImage] = useState(null);
  const [showInterestInput, setShowInterestInput] = useState(false);
  const [loader, setLoader] = useState(false);

  const SaveisUnderAge = (grade_save, ageLimit = 13) => {
    if (!grade_save) return true; // no grade selected → treat as under age
    return !["1", "2", "3", "4", "5", "6", "7"].includes(grade_save.trim());
  };
  const isUnderAge = (selDate, ageLimit = 13) => {
    return !["1", " 2", "3", "4", "5", "6", "7"].includes(formState.grade);
  };
  const [formState, setFormState] = useState(() => {
    const savedFormData = JSON.parse(localStorage.getItem("student_formState"));
    // const savedFormData = JSON.parse(localStorage.getItem("student_formState") || "{}");
    try {
      let imagefile;

      // if(SaveisUnderAge(savedFormData?.grade)){
      //   setSelectedImage(animal_avtar_1);
      //   imagefile = convertImagePathToBlob(animal_avtar_1);
      // }

      if (
        savedFormData?.gender === "2" &&
        (!selectedImage || SaveisUnderAge(savedFormData?.grade))
      ) {
        setSelectedImage(girl_under_age_1);

        imagefile = convertImagePathToBlob(girl_under_age_1);
      } else if (
        savedFormData?.gender === "1" &&
        (!selectedImage || SaveisUnderAge(savedFormData?.grade))
      ) {
        setSelectedImage(boy_under_age_1);
        imagefile = convertImagePathToBlob(boy_under_age_1);
        // const fetchImage = async (animal_avtar_1) => {
        //   const imageFile = await convertImagePathToBlob(animal_avtar_1);
        //   return imageFile // This is the actual File object
        //   // You can use imageFile here
        // };

        // imagefile = fetchImage(animal_avtar_1)
      } else if (
        savedFormData?.gender === "2" &&
        !SaveisUnderAge(savedFormData?.grade)
      ) {
        setSelectedImage(girl_under_age_1);
        imagefile = convertImagePathToBlob(girl_under_age_1);
      } else if (
        savedFormData?.gender === "1" &&
        !SaveisUnderAge(savedFormData?.grade)
      ) {
        setSelectedImage(boy_under_age_1);
        imagefile = convertImagePathToBlob(boy_under_age_1);
      }

      savedFormData.student_profile_pic = imagefile;

      if (savedFormData?.dob) {
        savedFormData.dob = dayjs(new Date(savedFormData?.dob));
      }

      setFormState(savedFormData);
    } catch (error) {}
    return savedFormData
      ? savedFormData
      : {
          name: null,
          grade: null,
          email: globalState?.email ?? "",
          dob: "",
          gender: null,
          language: "",
          location: null,
          country_code: "+1",
          student_profile_pic: null,
          introduction: "",
          interest_names: "",
          subject: "",
        };
  });

  // Subject chips/suggestions/validation are shared with SubjectOnlyPopup.
  const {
    subjects,
    subjectInput,
    setSubjectInput,
    suggestions: defaultSubjects,
    error: subjectError,
    validating: validatingSubjects,
    addSubject,
    removeSubject,
    validate: validateSubjects,
  } = useSubjectSelection(
    token,
    Array.isArray(formState.subject) ? formState.subject : [],
  );

  // Mirror the shared chip list back into the wizard payload.
  useEffect(() => {
    setFormState((prev) => ({ ...prev, subject: subjects }));
  }, [subjects]);

  useEffect(() => {
    const fetchProfilePic = async () => {
      if (!formState.gender) return;

      if (isUnderAge()) {
        // If under age, do not set image based on gender
        let imagefile;
        if (
          formState?.gender === "2" &&
          (!selectedImage || SaveisUnderAge(formState?.grade))
        ) {
          setSelectedImage(girl_under_age_1);

          imagefile = await convertImagePathToBlob(girl_under_age_1);
        } else if (
          formState?.gender === "1" &&
          (!selectedImage || SaveisUnderAge(formState?.grade))
        ) {
          setSelectedImage(boy_under_age_1);
          imagefile = await convertImagePathToBlob(boy_under_age_1);
        } else if (
          formState?.gender === "2" &&
          !SaveisUnderAge(formState?.grade)
        ) {
          setSelectedImage(girl_under_age_1);
          imagefile = await convertImagePathToBlob(girl_under_age_1);
        } else if (
          formState?.gender === "1" &&
          !SaveisUnderAge(formState?.grade)
        ) {
          setSelectedImage(boy_under_age_1);
          imagefile = await convertImagePathToBlob(boy_under_age_1);
        }

        setFormState((prev) => ({ ...prev, student_profile_pic: imagefile }));
        return;
      }

      let imagefile;

      setSelectedImage(null);

      setSelectedImage(animal_avtar_1);
      imagefile = await convertImagePathToBlob(animal_avtar_1);

      setFormState((prev) => ({ ...prev, student_profile_pic: imagefile }));
    };

    fetchProfilePic();
  }, [formState.gender, formState.grade]); // Runs when gender changes

  const [formErrors, setFormErrors] = useState({
    name: "",
    grade: "",
    email: "",
    dob: "",
    gender: "",
    language: "",
    location: "",
    student_profile_pic: "",
    introduction: "",
    interest_names: "",
    subject: "",
  });
  const [hasSelectedPlace, setHasSelectedPlace] = useState(false);
  const handlePlaceSelect = (place) => {
    if (place && place.formatted_address) {
      setFormState((prev) => ({
        ...prev,
        location: place.formatted_address,
      }));
      setFormErrors({ location: "" });
      setHasSelectedPlace(true);
    } else {
      setFormErrors({ location: "Please enter a valid location" });
    }
  };

  const handleAutocompleteInputChange = (event) => {
    setFormState((prev) => ({
      ...prev,
      location: event.target.value,
    }));
    if (event.target.value === "" || !hasSelectedPlace) {
      setFormErrors({ location: "Please enter a valid location" });
      setHasSelectedPlace(false);
    } else {
      setFormErrors({ location: "" });
    }
  };

  const handleInputBlur = () => {
    if (!hasSelectedPlace && formState.location) {
      setFormState((prev) => ({
        ...prev,
        location: "",
      }));
      setFormErrors({ location: "Please enter a valid location" });
    }
  };

  useEffect(() => {
    api
      .get("/courses/get-grade-list/", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setGradedetails(response.data.grade);
        }
      })
      .catch((error) => {});

    api
      .get("/auth/get-datalist/")
      .then((response) => {
        setAddtoLanguages(response.data.languages);
      })
      .catch((error) => {});
    api
      .get("/students/interests/")
      .then((response) => {
        const filteredInterests = response.data.data.filter(
          (interest) => interest.name && interest.name.trim() !== "",
        );
        setAddtointerest(filteredInterests);
        setTempVariable(filteredInterests);
      })
      .catch((error) => {});
    if (globalState?.locationData === undefined) {
      GetCountryCodeViaIp().then((response) => {
        updateState("locationData", response);
        setSelectedCountry({
          name: response?.country_name,
          iso2: response?.country_code?.toLowerCase(),
          dialCode: response?.country_calling_code?.replace("+", ""),
          format: "+...-...-....",
          hasAreaCodes: false,
        });
      });
    }

    AOS.init({
      duration: 500,
    });
  }, []);
  const handleBeginJourney = () => {
    setShowWelcomeFolder(false);
  };

  const [inputValue, setInputValue] = useState("");
  const [intrest, setIntrests] = useState([...formState.interest_names]);

  // Function to handle Enter key press in the input field
  const handleInputKeyPress = async (event) => {
    const innerInputValue = event.target.value.trim(); // Trim the input value

    if (event.key === "Enter" && innerInputValue !== "") {
      event.preventDefault();

      // Convert the input value to lowercase for case-insensitive comparison
      const lowerCaseInputValue = innerInputValue.toLowerCase();

      // Check if the lowercase input value already exists in the interests array (converted to lowercase)
      const exists = intrest.some(
        (interest) => interest.trim().toLowerCase() === lowerCaseInputValue,
      );

      if (!exists) {
        setIntrests([...intrest, lowerCaseInputValue]);
        event.target.value = "";
        addSuggestion(lowerCaseInputValue.trim());
        setsubsinput("");
      } else {
        toast.dismiss();
        toast.error(`Interest already added.`, {
          position: "top-center",
        });
      }
    }
  };

  const addSuggestion = (suggestion) => {
    const exists = intrest.includes(suggestion);

    if (exists) {
    } else {
      setIntrests([...intrest, suggestion]);
      setFormState((prev) => ({
        ...prev,
        interest_names: [...intrest, suggestion],
      }));
      setShowInterestInput(true);
      let errors = {};
      if ([...intrest, suggestion].length < 1) {
        errors.interest_names = "Please enter atleast one Interest.";
      }
      setFormErrors(errors);
    }
  };
  const removeInterest = (interestToRemove) => {
    const updatedSubjects = intrest.filter(
      (intrest) => intrest !== interestToRemove,
    );
    setIntrests(updatedSubjects);
    setFormState((prev) => ({
      ...prev,
      interest_names: updatedSubjects,
    }));
    let errors = {};
    if (updatedSubjects.length < 1) {
      errors.interest_names = "Please enter alteast one Interest.";
      setShowInterestInput(false);
    }
    setFormErrors(errors);
  };

  const [step, setStep] = useState(1);

  const onNext = () => {
    setStep(step + 1);
  };

  const onBack = () => {
    setStep(step - 1);
  };

  const fields = globalState?.enabled_modules?.includes("allow_add_subjects")
    ? [
        {
          id: 1,
          label: "Student Profile Details",
        },
        {
          id: 2,
          label: "About Me",
        },
        {
          id: 3,
          label: "Subjects",
        },
        {
          id: 4,
          label: "Interests",
        },
      ]
    : [
        {
          id: 1,
          label: "Student Profile Details",
        },
        {
          id: 2,
          label: "About Me",
        },
        {
          id: 3,
          label: "Interests",
        },
      ];

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const MAX_FILE_SIZE = 500 * 1024; // 500 KB
  const handleFileInput = async (event) => {
    const file = event.target.files[0];
    setImageUploaded(false);
    // Check if a file was selected
    if (!file) {
      setSrc(null); // Clear the src
      return;
    }

    if (file.size > 31457280) {
      toast.error("The file size exceeds the maximum limit of 30 MB");
      setFormErrors({
        ...formErrors,
        student_profile_pic: "The file size exceeds the maximum limit of 30 MB",
      });
      setSrc(null);
      return; // Exit the function
    }

    const compressedImage = await compressImage(file);

    setSrc(URL.createObjectURL(compressedImage));
    if (imageUploaded) {
      setSelectedImage(URL.createObjectURL(compressedImage));
    }
    onOpenModal();

    let error = "";
    error = isRequired(file);
    setFormErrors({
      ...formErrors,
      student_profile_pic: error,
    });
  };

  const onOpenModal = () => {
    setModalIsOpen(true);
  };

  const onCloseModal = () => {
    setModalIsOpen(false);
  };

  const triggerFileInput = () => {
    const fileInput = document.getElementById("choos-profile-image");
    fileInput.click();
  };

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleCountryChange = (e) => {
    const country = allCountries.find((c) => c.iso2 === e.target.value);
    setSelectedCountry(country);

    setFormErrors({
      ...formErrors,
      country_code: isValidMobileNumber(
        formState.phone,
        selectedCountry.dialCode,
      ),
    });
    setFormState({
      ...formState,
      country_code: `+${country.dialCode}`,
    });
  };

  const [selectedCountry, setSelectedCountry] = useState({
    name: globalState?.locationData
      ? globalState?.locationData?.country_name
      : "United States",
    iso2: globalState?.locationData
      ? globalState?.locationData?.country_code?.toLowerCase()
      : "us",
    dialCode: globalState?.locationData
      ? globalState?.locationData?.country_calling_code?.replace("+", "")
      : "1",
    format: "+...-...-....",
    hasAreaCodes: false,
  });
  const handleInputChange = async (event) => {
    const { name, value } = event.target;

    let error = "";
    if (name === "name") {
      error = isRequired(value) || isValidName(value);
    } else if (name === "grade") {
      error = isRequired(value);
    } else if (name === "email") {
      error = isRequired(value) || isValidEmail(value);
    } else if (name === "gender") {
      error = value === "" || value === "0" ? "Please select gender" : "";
    } else if (name === "language") {
      error = isRequired(value);
    } else if (name === "location") {
      error = isRequired(value);
    } else if (name === "introduction") {
      error = isRequired(value);
    } else if (name === "interest_names") {
      error = isRequired(value);
    } else if (name === "country_code") {
      error = isValidMobileNumber(value, selectedCountry.dialCode);
    }

    setFormErrors({
      ...formErrors,
      [name]: error,
    });
    if (event.key === "Enter" && value !== "" && name === "intrest") {
      setIntrests([...intrest, value]);
      setInputValue("");
    } else if (value !== "" && name === "language") {
      const selectedOptions = Array.from(
        event.target.selectedOptions,
        (option) => option.value,
      );

      setFormState((prev) => ({ ...prev, [name]: selectedOptions }));
    } else if (name === "gender") {
      setFormState((prev) => ({ ...prev, [name]: value }));

      if (isUnderAge()) {
        // If under age, do not set image based on gender
        let imagefile;
        setSelectedImage(null);
        if (value === "2") {
          setSelectedImage(girl_under_age_1);
          imagefile = await convertImagePathToBlob(girl_under_age_1);
        } else if (value === "1") {
          setSelectedImage(boy_under_age_1);
          imagefile = await convertImagePathToBlob(boy_under_age_1);
        }

        setFormState((prev) => ({
          ...prev,
          student_profile_pic: imagefile,
        }));
        return;
      }
      let imagefile;
      setSelectedImage(null);

      setSelectedImage(animal_avtar_1);
      imagefile = await convertImagePathToBlob(animal_avtar_1);

      setFormState((prev) => ({
        ...prev,
        student_profile_pic: imagefile,
      }));
    } else {
      setFormState((prev) => ({ ...prev, [name]: value }));
    }

    if (value.length > 1000) {
      setFormErrors((prevState) => ({
        ...prevState,
        introduction: "The introduction cannot exceed 1000 characters.",
      }));
    } else {
      setFormErrors((prevState) => ({
        ...prevState,
        introduction: "",
      }));
    }
  };

  const handleDateChanged = (date) => {
    let error = "";
    error = isRequired(date);
    setFormErrors({
      ...formErrors,
      dob: error,
    });
    setFormState((prev) => ({
      ...prev,
      dob: format(date.toDate(), "yyyy-MM-dd"),
    }));
  };
  const onSelectUnderAgeAvatar = async (image) => {
    let imagefile;
    setSelectedImage(null);

    if (formState.gender === "2" && !isUnderAge()) {
      setSelectedImage(image);
      imagefile = await convertImagePathToBlob(image);
    } else if (formState.gender === "1" && !isUnderAge()) {
      setSelectedImage(image);
      imagefile = await convertImagePathToBlob(image);
    } else {
      setSelectedImage(image);
      imagefile = await convertImagePathToBlob(image);
    }

    setFormState((prev) => ({
      ...prev,
      student_profile_pic: imagefile,
    }));
  };

  function isValidDate(val) {
    let today = new Date();
    let twentyOneYearsAgo = new Date();
    twentyOneYearsAgo.setFullYear(today.getFullYear() - 4);
    twentyOneYearsAgo.setHours(0, 0, 0, 0); // Set time to the start of the day

    let selectedDate = new Date(val);
    selectedDate.setHours(0, 0, 0, 0); // Set time to the start of the day

    // Check if the selected date is after today or if it is less than 21 years ago
    if (selectedDate > today || selectedDate > twentyOneYearsAgo) {
      return false;
    }
    return true;
  }
  const getFourYearsAgoDate = () => {
    let fourYearsAgo = new Date();
    fourYearsAgo.setFullYear(fourYearsAgo.getFullYear() - 4);
    fourYearsAgo.setHours(0, 0, 0, 0); // Set time to the start of the day
    return fourYearsAgo;
  };
  const [loading, setLoading] = useState(false);

  const handleForm1Submit = async (e) => {
    e.preventDefault();
    let errors = {};
    errors.name = formState.name
      ? formState.name.trim() === "" && "This field is required"
      : "This field is required";
    errors.grade = isRequired(formState.grade);
    errors.dob = isRequired(formState.dob);
    errors.gender =
      isRequired(formState.gender) ||
      (formState.gender === "" || formState.gender === "0"
        ? "Please select gender"
        : "");
    errors.email = isRequired(formState.email) || isValidEmail(formState.email);
    errors.language = isRequired(formState.language);
    errors.location =
      formState.location === "" || formState.location === null
        ? "Please enter a valid location"
        : "";

    setFormErrors(errors);

    if (!Object.values(errors).some((error) => error)) {
      onNext();
      setLoading(false);
    }
  };

  const handleForm2Submit = async (e) => {
    e.preventDefault();
    let errors = {};

    errors.introduction = formState.introduction
      ? formState.introduction.trim() === ""
        ? "This field is required"
        : formState.introduction.length > 1000
          ? "The introduction cannot exceed 1000 characters."
          : ""
      : "This field is required";
    setFormErrors(errors);
    if (!Object.values(errors).some((error) => error)) {
      onNext();
      setLoading(false);
    }
  };

  const fetchStudentDashbaord = () => {
    api
      .get("/students/get-student/", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.data.status === 200) {
          updateState("student_details", response?.data ?? {});
          if (response?.data?.data?.currency_symbol) {
            updateState(
              "currency_symbol",
              response?.data?.data?.currency_symbol,
            );
          }

          if (props?.isMarketplace) {
            props?.setLoader?.(true);
            api
              .post(
                `courses/student/my-courses-dashboard/v2/?page=1`,
                {},
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${token}`,
                  },
                },
              )
              .then((response) => {
                if (response.status === 200) {
                  updateState("student_courses", response?.data?.data ?? []);
                  if (response?.data?.data?.currency_symbol) {
                    updateState(
                      "currency_symbol",
                      response?.data?.data?.currency_symbol,
                    );
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => {
                props?.setLoader?.(false);
              });
          } else {
            api
              .get("/courses/student/my-courses-dashboard/", {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Token ${token}`,
                },
              })
              .then((response) => {
                if (response.status === 200) {
                  updateState("student_courses", response?.data?.data ?? []);
                  if (response?.data?.data?.currency_symbol) {
                    updateState(
                      "currency_symbol",
                      response?.data?.data?.currency_symbol,
                    );
                  }
                }
              })
              .catch((error) => {
                //
              });
          }
          api
            .get("/auth/get-teacher-list/", {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
              },
            })
            .then((response) => {
              if (response.data.status === 200) {
                updateState("get_teacher_list", response?.data ?? {});
              }
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {});
  };
  const [dobInputValue, setDobInputValue] = useState(
    formState.dob ? dayjs(formState.dob).format("MM/DD/YYYY") : "",
  );

  const handleDobInput = (e) => {
    const raw = e.target.value;

    // Handle backspace — allow deleting naturally
    if (raw.length < dobInputValue.length) {
      setDobInputValue(raw);
      if (raw.length < 10) {
        setFormState((prev) => ({ ...prev, dob: "" }));
      }
      return;
    }

    // Strip non-digits
    let digits = raw.replace(/\D/g, "");

    // Auto-insert slashes
    let value = digits;
    if (digits.length >= 3 && digits.length <= 4) {
      value = digits.slice(0, 2) + "/" + digits.slice(2);
    } else if (digits.length >= 5) {
      value =
        digits.slice(0, 2) +
        "/" +
        digits.slice(2, 4) +
        "/" +
        digits.slice(4, 8);
    }

    setDobInputValue(value);

    // Validate only when fully entered
    if (value.length === 10) {
      const parsed = dayjs(value, "MM/DD/YYYY", true);

      if (!parsed.isValid()) {
        setFormErrors((prev) => ({
          ...prev,
          dob: "Please enter a valid date (MM/DD/YYYY)",
        }));
        setFormState((prev) => ({ ...prev, dob: "" }));
        return;
      }

      const today = new Date();
      const selectedDate = parsed.toDate();
      const minDate = new Date();
      minDate.setFullYear(today.getFullYear() - 4); // must be at least 4 years old

      if (selectedDate > today) {
        setFormErrors((prev) => ({
          ...prev,
          dob: "Date of birth cannot be in the future",
        }));
        setFormState((prev) => ({ ...prev, dob: "" }));
        return;
      }

      if (selectedDate > minDate) {
        setFormErrors((prev) => ({
          ...prev,
          dob: "Student must be at least 4 years old",
        }));
        setFormState((prev) => ({ ...prev, dob: "" }));
        return;
      }

      // Valid date
      setFormState((prev) => ({ ...prev, dob: parsed.format("YYYY-MM-DD") }));
      setFormErrors((prev) => ({ ...prev, dob: "" }));
    } else {
      // Clear dob while still typing
      setFormState((prev) => ({ ...prev, dob: "" }));
      setFormErrors((prev) => ({ ...prev, dob: "" }));
    }
  };
  const submitForm = async (e) => {
    e.preventDefault();

    if (
      formState.interest_names === null ||
      formState.interest_names === undefined ||
      formState.interest_names?.length === 0
    ) {
      toast.error("Please select valid interests.", {
        position: "top-center",
      });
      setLoading(false);
      return;
    }

    // setLoading(true);

    const commaSeparatedInterestNames = formState.interest_names.join(",");

    setFormState((prev) => ({ ...prev, interest_names: "" }));
    setFormState((prev) => ({
      ...prev,
      interest_names: formState.interest_names,
    }));
    setFormState((prev) => ({ ...prev, country_code: "+91" }));
    let formData = new FormData();
    for (const [key, value] of Object.entries(formState)) {
      // only add the key if the value is not null
      if (value !== null) {
        formData.append(key, value);
      }
    }

    if (formState.dob) {
      formData.set("dob", dayjs(formState.dob).format("YYYY-MM-DD"));
    }

    if (
      !formState.student_profile_pic ||
      formState.student_profile_pic === "undefined"
      // (typeof formState.student_profile_pic === "object" && Object.keys(formState.student_profile_pic).length === 0)
    ) {
      formData.set("student_profile_pic", "");
    }
    // Perform the API call using Axios
    const url = "students/create-student/";
    const headers = {
      Authorization: `Token ${token}`,
    };
    setLoader(true);
    api
      .post(url, formData, { headers })
      .then(async (response) => {
        dispatch(resetProfileDetails());
        localStorage.removeItem("student_formState");
        document.body.style.overflow = "auto";
        updateState("student_details", response?.data ?? {});
        if (globalState?.enabled_modules?.includes("auto_course_generation")) {
          try {
            const { courses, teacherId } = await getAIGeneratedCourses(token);
            if (courses?.length > 0) {
              // courses.forEach((course) => {
              //   getAIGeneratedLessons(token, course?.course_id, teacherId);
              // });
              getAIGeneratedLessons(token, courses[0]?.course_id, teacherId);
            }
          } catch (error) {
            console.error("Failed to fetch AI-generated courses:", error);
          }
        }
        props.setProfilePopupStatus(false);
        props.setWelcomePopupStatus(true);
        localStorage.setItem("is_profile", "true");
        props.setIsProfileCreated?.(true);

        setTimeout(() => {
          props.setWelcomePopupStatus(false);
          updateState("has_profile", true);
        }, 3000);
        try {
          fetchStudentDashbaord();
        } catch (error) {
          console.error("Error fetching student dashboard:", error);
        }
        if (globalState.enabled_modules?.includes("auto_course_generation")) {
          props.setNewStudFirstRender(true);
          setTimeout(() => {
            props.setNewStudFirstRender(false);
          }, 30000);
        }
        if (redirectPath !== null && redirectPath !== "") {
          navigate(redirectPath);
          localStorage.removeItem("redirectAfterSignup");
        }
        if (redirectToCourse !== null && redirectToCourse !== "") {
          navigate(redirectToCourse);
          localStorage.removeItem("redirectToCourse");
        }
      })
      .catch((error) => {
        const errorStatus = error?.response?.status;
        const errorMessage =
          error?.response?.data?.message ||
          "Failed to create student profile. Please try again.";

        if (errorStatus === 400) {
          toast.error(errorMessage, {
            position: "top-center",
          });
        } else {
          toast.error(
            "Failed to create student profile. Please try again later.",
            {
              position: "top-center",
            },
          );
        }
        try {
          fetchStudentDashbaord();
        } catch (error) {
          console.error("Error fetching student dashboard:", error);
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const keysAsArray = Object.keys(AddtoLanguages).map((key) => key);

  useEffect(() => {
    // Save the form state to local storage

    localStorage.setItem("student_formState", JSON.stringify(formState));
  }, [formState]);

  useEffect(() => {
    if (props.ProfilePopupStatus === true) {
      changeScrollPopup("hidden", "studentDashboar-popup-container");
    } else {
      changeScrollPopup("auto", "studentDashboar-popup-container");
    }
  }, [props.ProfilePopupStatus]);

  const [subsinput, setsubsinput] = useState("");

  const handleAddsubs = async (event) => {
    event.preventDefault();

    // Assuming you have the input value in the state (replace 'inputValue' accordingly)
    const innerInputValue = subsinput;

    // Convert the input value to lowercase for case-insensitive comparison
    const lowerCaseInputValue = innerInputValue.toLowerCase();

    // Check if the lowercase input value already exists in the interests array (converted to lowercase)
    const exists = intrest.some(
      (interest) => interest.trim().toLowerCase() === lowerCaseInputValue,
    );

    if (!exists) {
      setIntrests([...intrest, lowerCaseInputValue]);
      event.target.value = "";
      setsubsinput("");
      setShowInterestInput(true);
      setFormState((prev) => ({
        ...prev,
        interest_names: [...intrest, lowerCaseInputValue],
      }));

      let errors = {};
      errors = errors.interest_names = "";

      setFormErrors(errors);
    } else {
      toast.dismiss();
      toast.error(`Interest already added.`, {
        position: "top-center",
      });
    }
  };

  // Validate subjects, then advance to step 4 only
  const handleForm3Submit = async (e) => {
    e.preventDefault();
    const isValid = await validateSubjects();
    if (!isValid) return;
    onNext();
  };

  return (
    <>
      <div className="studentDashboar-popup-section relative">
        <div className="studentDashboar-popup-wrapper">
          <div className="studentDashboar-popup-container">
            {showWelcomeFolder ? ( // Conditional rendering based on showWelcomeFolder state
              <div
                className="dashboard-popup-welcome-folder"
                data-aos="zoom-in"
              >
                <div className="dashboard-popup-welcome-image">
                  <img src={dashboard_popup_welcome_image} alt="" />
                </div>
                <h2>Welcome!</h2>
                <p> Let's Create Your Student Profile.</p>
                <button
                  type="button"
                  className="begin-journey-btn"
                  onClick={handleBeginJourney}
                >
                  Create Profile
                </button>
              </div>
            ) : (
              <div className="dashboard-popup-form-wrapper">
                {/* {loader && 
                <div  className="absolute inset-0 z-[100] flex flex-col items-center justify-center gap-4 bg-white/90"
      aria-busy="true"
      aria-live="polite">
                                      <img
                                        className="w-[20rem] border rounded-md border-gray-700 shadow-[0_0_25px_rgba(0,0,0,0.15)]"
                                        src={lessonGif}
                                        alt="Loading..."
                                        loading="eager"
                                        fetchpriority="high"
                                        decoding="async"
                                      />
                                    </div>} */}
                {fields.map((field, index) => {
                  if (step === 1) {
                    return (
                      <div
                        key={field.id}
                        className="dashboard-popup-teacher-profile-details-folder"
                      >
                        <div className="dashboard-popup-teacher-profile-details-title">
                          <div className="dashboard-popup-teacher-profile-details-image">
                            <img
                              src={dashboard_popup_teacher_profile_details_icon}
                              alt=""
                            />
                          </div>
                          <h2>{fields[step - 1].label}</h2>
                        </div>
                        <div className="dashboard-popup-teacher-profile-details-form h-[75%]">
                          <div className="dashboard-popup-teacher-profile-details-form-container">
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Name</label>
                              <input
                                type="name"
                                name="name"
                                autocomplete="off"
                                style={
                                  formErrors.name
                                    ? { border: "1px solid red" }
                                    : null
                                }
                                value={formState.name || ""}
                                placeholder="Full name"
                                onChange={handleInputChange}
                              />
                              <div className="form-icon">
                                <img src={profile_image} alt="" />
                              </div>
                              <p>{formErrors.name}</p>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Grade</label>
                              <select
                                id="gendar-select-feild"
                                className="student_grade_select"
                                name="grade"
                                style={
                                  formErrors.grade
                                    ? {
                                        border: "1px solid red",
                                        borderRadius: 6,
                                        color: formState.grade
                                          ? "#000"
                                          : "#626262",
                                      }
                                    : {
                                        border: "1px solid #BDBDBD",
                                        borderRadius: 6,
                                        color: formState.grade
                                          ? "#000"
                                          : "#626262",
                                      }
                                }
                                value={formState.grade || ""}
                                onChange={handleInputChange}
                              >
                                <option value="">Select Grade</option>
                                {Object.keys(gradedetails).map((key) => (
                                  <option
                                    key={`gradedetails${key}`}
                                    value={key}
                                  >
                                    {gradedetails[key]}
                                  </option>
                                ))}
                              </select>
                              <div className="form-icon">
                                <img src={grade_image} alt="" />
                              </div>
                              <p>{formErrors.grade}</p>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Email</label>
                              <input
                                type="text"
                                placeholder="email id"
                                autocomplete="off"
                                name="email"
                                readOnly
                                style={
                                  formErrors.email
                                    ? { border: "1px solid red" }
                                    : null
                                }
                                value={formState.email || ""}
                                onChange={handleInputChange}
                              />
                              <div className="form-icon">
                                <img src={email_image} alt="" />
                              </div>
                              <p>{formErrors.email}</p>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Gender</label>
                              <div className="dashboard-popup-teacher-profile-gender-folder">
                                <select
                                  id="gendar-select-feild"
                                  name="gender"
                                  style={
                                    formErrors.gender
                                      ? { border: "1px solid red" }
                                      : null
                                  }
                                  value={formState.gender || ""}
                                  onChange={handleInputChange}
                                >
                                  {genders.map((gender) => {
                                    return (
                                      <option
                                        key={gender.value}
                                        value={gender.value}
                                      >
                                        {gender.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                              <div className="form-icon">
                                <img src={gender_image} alt="" />
                              </div>
                              <p>{formErrors.gender}</p>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Birth Date</label>
                              {/* <Datetime
                                name="dob"
                                className={formErrors.dob ? "datetime-error" : "datetime"}
                                timeFormat={false}
                                inputProps={{
                                  placeholder: "MM/DD/YYYY",
                                  value: dobInputValue,
                                  onChange: handleDobInput,
                                  onBlur: () => {
                                    if (dobInputValue.length > 0 && dobInputValue.length < 10) {
                                      setFormErrors((prev) => ({ ...prev, dob: "Please enter complete date (MM/DD/YYYY)" }));
                                    }
                                  },
                                  maxLength: 10,
                                  style: formErrors.dob ? { border: "1px solid red" } : null,
                                }}
                                value={dobInputValue}
                                closeOnSelect={true}
                                onChange={(date) => {
                                  if (typeof date === "object" && date?.isValid && date.isValid()) {
                                    const selectedDate = date.toDate();
                                    const today = new Date();
                                    const minDate = new Date();
                                    minDate.setFullYear(today.getFullYear() - 4);
                                    if (selectedDate > today) {
                                      setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
                                      return;
                                    }
                                    if (selectedDate > minDate) {
                                      setFormErrors((prev) => ({ ...prev, dob: "Student must be at least 4 years old" }));
                                      return;
                                    }
                                    setDobInputValue(date.format("MM/DD/YYYY"));
                                    setFormState((prev) => ({ ...prev, dob: date.format("YYYY-MM-DD") }));
                                    setFormErrors((prev) => ({ ...prev, dob: "" }));
                                  }
                                }}
                                dateFormat="MM/DD/YYYY"
                                isValidDate={isValidDate}
                              /> */}

                              <FloatingDateTime
                                className={
                                  formErrors.dob ? "datetime-error" : "datetime"
                                }
                                timeFormat={false}
                                dateFormat="MM/DD/YYYY"
                                value={dobInputValue}
                                initialViewDate={
                                  formState.dob ? undefined : maxBirthDate
                                }
                                isValidDate={isValidDate}
                                inputProps={{
                                  placeholder: "MM/DD/YYYY",
                                  value: dobInputValue,
                                  onChange: handleDobInput,
                                  onBlur: () => {
                                    if (
                                      dobInputValue.length > 0 &&
                                      dobInputValue.length < 10
                                    ) {
                                      setFormErrors((prev) => ({
                                        ...prev,
                                        dob: "Please enter complete date (MM/DD/YYYY)",
                                      }));
                                    }
                                  },
                                  maxLength: 10,
                                  style: formErrors.dob
                                    ? { border: "1px solid red" }
                                    : null,
                                }}
                                onChange={(date) => {
                                  if (
                                    typeof date === "object" &&
                                    date?.isValid &&
                                    date.isValid()
                                  ) {
                                    const selectedDate = date.toDate();
                                    const today = new Date();
                                    const minDate = new Date();
                                    minDate.setFullYear(
                                      today.getFullYear() - 4,
                                    );
                                    if (selectedDate > today) {
                                      setFormErrors((prev) => ({
                                        ...prev,
                                        dob: "Date of birth cannot be in the future",
                                      }));
                                      return;
                                    }
                                    if (selectedDate > minDate) {
                                      setFormErrors((prev) => ({
                                        ...prev,
                                        dob: "Student must be at least 4 years old",
                                      }));
                                      return;
                                    }
                                    setDobInputValue(date.format("MM/DD/YYYY"));
                                    setFormState((prev) => ({
                                      ...prev,
                                      dob: date.format("YYYY-MM-DD"),
                                    }));
                                    setFormErrors((prev) => ({
                                      ...prev,
                                      dob: "",
                                    }));
                                  }
                                }}
                              />

                              <div className="form-icon">
                                <img src={calender_image} alt="" />
                              </div>
                              <p>{formErrors.dob}</p>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Language</label>
                              <div className="dashboard-popup-teacher-profile-gender-folder">
                                <select
                                  id="gendar-select-feild"
                                  name="language"
                                  style={
                                    formErrors.language
                                      ? {
                                          border: "1px solid red",
                                          borderRadius: 6,
                                        }
                                      : {
                                          border: "1px solid #BDBDBD",
                                          borderRadius: 6,
                                        }
                                  }
                                  value={formState.language || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Language</option>
                                  {keysAsArray.map((key) => (
                                    <option key={key} value={key}>
                                      {AddtoLanguages[key]}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="form-icon">
                                <img src={language_image} alt="" />
                              </div>
                              <p>{formErrors.language}</p>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-input">
                              <label>Location</label>
                              <Autocomplete
                                apiKey={GOOGLE_MAP_KEY}
                                onPlaceSelected={handlePlaceSelect}
                                defaultValue={formState.location}
                                onChange={handleAutocompleteInputChange}
                                onBlur={handleInputBlur}
                                options={{
                                  types: ["(cities)"],
                                }}
                              />

                              <div className="form-icon location-icon">
                                <img src={location_image} alt="" />
                              </div>
                              <p>{formErrors.location}</p>
                            </div>
                          </div>
                          <div className="dot-indicator">
                            {fields.map((field, index) => (
                              <div
                                key={field.id}
                                className={`dot ${
                                  index + 1 === step ? "active" : ""
                                }`}
                              ></div>
                            ))}
                          </div>
                        </div>
                        {successMessage && (
                          <p className="success-message">{successMessage}</p>
                        )}
                        {errorMessage && (
                          <p className="error-message">{errorMessage}</p>
                        )}
                        <div className="form-buttons">
                          {loading ? (
                            <div className="loading-spinner"></div> // Display the loading spinner
                          ) : (
                            <button
                              onClick={handleForm1Submit}
                              className="form-buttons dashboard-form-next-btn"
                            >
                              Next
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  }
                  if (step === 2) {
                    return (
                      <div
                        key={field.id}
                        className="dashboard-popup-teacher-profile-details-folder"
                      >
                        <div className="dashboard-popup-teacher-profile-details-title">
                          <div className="dashboard-popup-teacher-profile-details-image">
                            <img
                              src={dashboard_popup_teacher_profile_details_icon}
                              alt=""
                            />
                          </div>
                          <h2>{fields[step - 1].label}</h2>
                        </div>
                        <div className="dashboard-popup-teacher-profile-details-form h-[75%]">
                          {!isUnderAge() ? (
                            <div
                              className={` dashboard-popup-teacher-profile-details-image-underage  ${
                                isOthersGender(formState.gender) ? "others" : ""
                              }`}
                            >
                              <div
                                className={`profile-image-section  ${
                                  isOthersGender(formState.gender)
                                    ? "others"
                                    : ""
                                }`}
                              >
                                <span>Profile Picture</span>
                                <img
                                  className="profile-image"
                                  src={selectedImage ?? animal_avtar_1}
                                  alt=""
                                />
                              </div>
                              <div className={`profile-image-section2`}>
                                <span>Select Avatar</span>
                                <div className={`select-avatar-list`}>
                                  {[
                                    animal_avtar_1,
                                    animal_avtar_2,
                                    animal_avtar_3,
                                    animal_avtar_4,
                                    animal_avtar_5,
                                    animal_avtar_6,
                                    animal_avtar_7,
                                    animal_avtar_8,
                                    animal_avtar_9,
                                    animal_avtar_10,
                                  ].map((item) => (
                                    <img
                                      className={`select-avatar-image ${
                                        selectedImage === item ? "active" : ""
                                      }
                                        
                                        `}
                                      onClick={() =>
                                        onSelectUnderAgeAvatar(item)
                                      }
                                      key={item}
                                      src={item}
                                      alt=""
                                    />
                                  ))}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span>Upload Profile Picture</span>
                              <div className="Personalize-your-AI-Assistant-uplode-image">
                                <div>
                                  <img
                                    src={
                                      selectedImage
                                        ? selectedImage
                                        : Number(
                                              JSON.parse(
                                                localStorage.getItem(
                                                  "student_formState",
                                                ),
                                              ).gender,
                                            ) == 1
                                          ? boy_under_age_1
                                          : Number(
                                                JSON.parse(
                                                  localStorage.getItem(
                                                    "student_formState",
                                                  ),
                                                ).gender,
                                              ) == 2
                                            ? girl_under_age_1
                                            : uplode_image
                                    }
                                    alt=""
                                    style={
                                      formErrors.student_profile_pic
                                        ? { border: "1px solid red" }
                                        : null
                                    }
                                  />
                                  <p className="errorState">
                                    {" "}
                                    {formErrors.student_profile_pic}
                                  </p>
                                </div>
                                <div
                                  className="dashboard-popup-teacher-profile-details-image-plus-btn black-plus-icon"
                                  onChange={triggerFileInput}
                                  style={{ cursor: "pointer" }}
                                >
                                  <span>
                                    <i class="fa-solid fa-plus"></i>
                                  </span>
                                </div>
                                <input
                                  type="file"
                                  id="choos-profile-image"
                                  name="student_profile_pic"
                                  key={Math.random()} // Add a random key to reset the input field
                                  onChange={handleFileInput}
                                  accept="image/png, image/jpeg" // Accept only image files
                                  style={{
                                    height: 106,
                                    width: 106,
                                  }}
                                />
                              </div>
                            </>
                          )}
                          <p className="introduce-yourself-title">
                            Introduce Yourself.
                          </p>
                          <textarea
                            name="introduction"
                            value={formState.introduction || ""}
                            style={
                              formErrors.introduction
                                ? { border: "1px solid red" }
                                : null
                            }
                            onChange={handleInputChange}
                            className="introduce-yourself-text"
                            type="text"
                            cols="30"
                            rows="10"
                            placeholder={`For Example:\n• Tell us about yourself.\n• What is your favorite subject?\n• Do you have any hobbies or interests you're passionate about?\n• What are your goals or aspirations for the future?\n`}
                          ></textarea>
                          <p className="errorState">
                            {formErrors.introduction}
                          </p>
                          <div className="dot-indicator">
                            {fields.map((field, index) => (
                              <div
                                key={field.id}
                                className={`dot ${
                                  index + 1 === step ? "active" : ""
                                }`}
                              ></div>
                            ))}
                          </div>
                        </div>
                        <span className="you-can-update-the-details-title">
                          {" "}
                          Note: You can update these details anytime from
                          profile settings.
                        </span>
                        {successMessage && (
                          <p className="success-message">{successMessage}</p>
                        )}
                        {errorMessage && (
                          <p className="error-message">{errorMessage}</p>
                        )}

                        {loading ? (
                          <div className="loading-spinner"></div> // Display the loading spinner
                        ) : (
                          <div className="form-buttons">
                            {step > 1 && <button onClick={onBack}>Back</button>}
                            {step < fields.length ? (
                              <button onClick={handleForm2Submit}>Next</button>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                    );
                  }
                  if (step === 3) {
                    return (
                      <>
                        {globalState?.enabled_modules?.includes(
                          "allow_add_subjects",
                        ) ? (
                          <div
                            key={field.id}
                            className="dashboard-popup-teacher-profile-details-folder"
                          >
                            {(loader || validatingSubjects) && (
                              <Loader text={"Validating your subjects..."} />
                            )}
                            <div className="dashboard-popup-teacher-profile-details-title">
                              <div className="dashboard-popup-teacher-profile-details-image ml-1">
                                {/* <img
                              src={dashboard_popup_teacher_profile_details_icon}
                              alt=""
                            /> */}
                                <SubjectIcon />
                              </div>
                              <h2>{fields[step - 1].label}</h2>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-form">
                              <SubjectSelector
                                subjects={subjects}
                                onAdd={addSubject}
                                onRemove={removeSubject}
                                suggestions={defaultSubjects}
                                inputValue={subjectInput}
                                onInputChange={setSubjectInput}
                                error={subjectError}
                              />
                              <div className="dot-indicator">
                                {fields.map((field, index) => (
                                  <div
                                    key={field.id}
                                    className={`dot ${
                                      index + 1 === step ? "active" : ""
                                    }`}
                                  ></div>
                                ))}
                              </div>
                            </div>
                            <div className="form-buttons">
                              {step > 1 && (
                                <button onClick={onBack} disabled={loading}>
                                  Back
                                </button>
                              )}
                              {/* Step 3 always advances to step 4 only */}
                              <button onClick={handleForm3Submit}>Next</button>
                            </div>
                          </div>
                        ) : (
                          <div
                            key={field.id}
                            className="dashboard-popup-teacher-profile-details-folder"
                          >
                            {loader && (
                              <Loader
                                text={"Creating your student profile..."}
                              />
                            )}

                            <div className="dashboard-popup-teacher-profile-details-title">
                              <div className="dashboard-popup-teacher-profile-details-image ml-1">
                                {/* <img
                              src={dashboard_popup_teacher_profile_details_icon}
                              alt=""
                            /> */}
                                <InterestIcon />
                              </div>
                              <h2>{fields[step - 1].label}</h2>
                            </div>
                            <div className="dashboard-popup-teacher-profile-details-form">
                              <p className="subjects-title">
                                Select your interests
                              </p>
                              {showInterestInput && (
                                <div className="Subjects-you-teach-feilds-folder">
                                  {intrest.map((intrest, index) => (
                                    <div
                                      key={index}
                                      className="Subjects-you-teach-feilds"
                                    >
                                      <p>{intrest}</p>
                                      <a
                                        className="subject-delete-btn"
                                        onClick={() => removeInterest(intrest)}
                                      >
                                        <i className="fa-solid fa-xmark"></i>
                                      </a>
                                    </div>
                                  ))}
                                </div>
                              )}
                              {globalState.enabled_modules?.includes(
                                "allow_add_interest",
                              ) && (
                                <div className="add_feild-btn">
                                  <div className="Subjects-you-teach">
                                    <input
                                      value={subsinput}
                                      name="interest_names"
                                      spellCheck
                                      type="text"
                                      placeholder="Add custom interest"
                                      onKeyUp={handleInputKeyPress}
                                      onChange={(e) => {
                                        e.preventDefault();
                                        setsubsinput(e.target.value);
                                      }}
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    className="add_subject_feild_btn flex items-center justify-center gap-1"
                                    onClick={handleAddsubs}
                                    disabled={
                                      subsinput.trim() === "" ||
                                      subsinput === null ||
                                      subsinput === undefined
                                    }
                                    style={{
                                      backgroundColor:
                                        (subsinput.trim() === "" ||
                                          subsinput === null ||
                                          subsinput === undefined) &&
                                        "#CCCCCC",
                                    }}
                                  >
                                    Add <PlusIcon w={12} h={12} />
                                  </button>
                                </div>
                              )}

                              <div className="Subjects-you-teach-suggestions-container">
                                <p className="Subjects-you-teach-suggestions-title">
                                  {/* Suggestions */}
                                </p>
                                <div className="Subjects-you-teach-suggestions-folder">
                                  {Addtointerest
                                    ? Addtointerest?.filter(
                                        (obj) =>
                                          obj?.name !== "" &&
                                          !intrest.includes(obj?.name),
                                      ).map((obj, index) => (
                                        <a
                                          key={index}
                                          onClick={() =>
                                            addSuggestion(obj.name)
                                          }
                                        >
                                          {obj.name}
                                        </a>
                                      ))
                                    : null}
                                </div>
                              </div>
                              <p className="errorState">
                                {formErrors.interest_names}
                              </p>
                              <div className="dot-indicator">
                                {fields.map((field, index) => (
                                  <div
                                    key={field.id}
                                    className={`dot ${
                                      index + 1 === step ? "active" : ""
                                    }`}
                                  ></div>
                                ))}
                              </div>
                            </div>
                            <div className="form-buttons">
                              {step > 1 && (
                                <button onClick={onBack} disabled={loading}>
                                  Back
                                </button>
                              )}
                              {step < fields.length ? (
                                <button onClick={onNext}>Next</button>
                              ) : (
                                <button
                                  onClick={submitForm}
                                  className="update-profile-image finish-button"
                                  disabled={
                                    formState.interest_names?.length === 0
                                  }
                                >
                                  {loader ? (
                                    <div className="loading-spinner"></div>
                                  ) : (
                                    "Finish"
                                  )}
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    );
                  }
                  if (step === 4) {
                    return (
                      <div
                        key={field.id}
                        className="dashboard-popup-teacher-profile-details-folder"
                      >
                        {loader && (
                          <Loader text={"Creating your student profile..."} />
                        )}

                        <div className="dashboard-popup-teacher-profile-details-title">
                          <div className="dashboard-popup-teacher-profile-details-image">
                            {/* <img
                              src={dashboard_popup_teacher_profile_details_icon}
                              alt=""
                            /> */}
                            <InterestIcon />
                          </div>
                          <h2>{fields[step - 1].label}</h2>
                        </div>
                        <div className="dashboard-popup-teacher-profile-details-form">
                          <p className="subjects-title">
                            Select your interests
                          </p>
                          {showInterestInput && (
                            <div className="Subjects-you-teach-feilds-folder">
                              {intrest.map((intrest, index) => (
                                <div
                                  key={index}
                                  className="Subjects-you-teach-feilds"
                                >
                                  <p>{intrest}</p>
                                  <a
                                    className="subject-delete-btn"
                                    onClick={() => removeInterest(intrest)}
                                  >
                                    <i className="fa-solid fa-xmark"></i>
                                  </a>
                                </div>
                              ))}
                            </div>
                          )}
                          {/* {showInterestInput && ( */}
                          {globalState.enabled_modules?.includes(
                            "allow_add_interest",
                          ) && (
                            <div className="add_feild-btn">
                              <div className="Subjects-you-teach">
                                <input
                                  value={subsinput}
                                  name="interest_names"
                                  spellCheck
                                  type="text"
                                  placeholder="Add custom interest"
                                  onKeyUp={handleInputKeyPress}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    setsubsinput(e.target.value);
                                  }}
                                />
                              </div>
                              <button
                                type="button"
                                className="add_subject_feild_btn flex items-center justify-center gap-1"
                                onClick={handleAddsubs}
                                disabled={
                                  subsinput.trim() === "" ||
                                  subsinput === null ||
                                  subsinput === undefined
                                }
                                style={{
                                  backgroundColor:
                                    (subsinput.trim() === "" ||
                                      subsinput === null ||
                                      subsinput === undefined) &&
                                    "#CCCCCC",
                                }}
                              >
                                Add <PlusIcon w={12} h={12} />
                              </button>
                            </div>
                          )}
                          {/* )} */}

                          <div className="Subjects-you-teach-suggestions-container">
                            <p className="Subjects-you-teach-suggestions-title">
                              {/* Suggestions */}
                            </p>
                            <div className="Subjects-you-teach-suggestions-folder">
                              {Addtointerest
                                ? Addtointerest?.filter(
                                    (obj) =>
                                      obj?.name !== "" &&
                                      !intrest.includes(obj?.name),
                                  ).map((obj, index) => (
                                    <a
                                      key={index}
                                      onClick={() => addSuggestion(obj.name)}
                                    >
                                      {obj.name}
                                    </a>
                                  ))
                                : null}
                            </div>
                          </div>
                          <p className="errorState">
                            {formErrors.interest_names}
                          </p>
                          <div className="dot-indicator">
                            {fields.map((field, index) => (
                              <div
                                key={field.id}
                                className={`dot ${
                                  index + 1 === step ? "active" : ""
                                }`}
                              ></div>
                            ))}
                          </div>
                        </div>
                        <div className="form-buttons">
                          {step > 1 && (
                            <button onClick={onBack} disabled={loading}>
                              Back
                            </button>
                          )}
                          {step < fields.length ? (
                            <button onClick={onNext}>Next</button>
                          ) : (
                            <button
                              onClick={submitForm}
                              className="update-profile-image finish-button"
                              disabled={formState.interest_names?.length === 0}
                            >
                              {loader ? (
                                <div className="loading-spinner"></div>
                              ) : (
                                "Finish"
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      {modalIsOpen && (
        <CropProfileImageModal
          src={src}
          setSrc={setSrc}
          setSelectedImage={setSelectedImage}
          setImageUploaded={setImageUploaded}
          setUplodedImage={setUplodedImage}
          modalStatus={modalIsOpen}
          setModalClose={onCloseModal}
          fieldName="student_profile_pic"
          setFormState={setFormState}
          formState={formState}
        />
      )}
    </>
  );
};

export default StudentPopupSection;
